import { render, staticRenderFns } from "./Uebergabe.vue?vue&type=template&id=08875398&scoped=true"
import script from "./Uebergabe.vue?vue&type=script&lang=ts"
export * from "./Uebergabe.vue?vue&type=script&lang=ts"
import style0 from "./Uebergabe.vue?vue&type=style&index=0&id=08875398&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08875398",
  null
  
)

export default component.exports